module.exports = require('./helpers/bundle-url').getBundleURL('47naU') + "logo-dark.eefe0b7f.svg";